import * as cmn from "../../common/NamaCommon";
import {ajaxJSON, areNotEqual, getFirstNotNullObj, isAnyEqualToFirst, isNullOrUndefined} from "../../common/NamaCommon";
import * as NamaURLS from "../../constants/NamaURLS";
import * as ItemButtonLevel from "../../constants/ItemButtonLevel";
import * as CommonConstants from "../../constants/CommonConstants";
import * as SCEntities from "../../constants/SCEntities";
import {JSCriteriaBuilder} from "../../common/JSCriteriaBuilder";
import * as Operator from "../../constants/Operator";
import * as ExpressionRelationship from "../../constants/ExpressionRelationship";
import {translateRef} from "../../common/Translator";
import {downloadURLBrRecordId} from "../../common/AttachmentLinkUtil";
import * as DownloadPurpose from "../../constants/DownloadPurpose";
import {ReferenceSelectorPopup} from "./SearcherWindow";
import * as DomainBaseFieldIDs from "../../constants/DomainBaseFieldIDs";
import {getCustomGUISettings} from "../../login/ClientCache";
import {NamaGridWidget} from "../../grid/NamaGridWidget";


let foreignKeyFieldIds = new Map();

export class InvItemCustomButton {
    /**
     *
     * @param {namaTypes.DTOAbsItemLevelLine} favouriteItem
     * @param {string} level
     * @param currentRecord
     */
    constructor(favouriteItem, level, currentRecord, parent, customPanel) {
        let that = this;
        that.favouriteItem = favouriteItem;
        that.level = level;
        that.currentRecord = currentRecord;
        that.parent = parent;
        that.customPanel = customPanel;
        if (level == ItemButtonLevel.Level1) {
            let favouritesLevel1 = favouriteItem.favouritesLevel1;
            cmn.ajaxJSON(NamaURLS.FIND_REF_BY_ID, {entityType: favouritesLevel1.entityType, id: favouritesLevel1.id}, (ref) => {
                that.currentRecord = ref;
                that.addButtonToPanel(parent);
            });
        } else {
            that.addButtonToPanel(parent);
        }

    }


    onButtonImageLoad() {
        let that = this;
        if (that.btnImg[0].naturalHeight === 1)
            that.element.find("img").remove();
        else
            that.element.find("span").addClass("itemBtnSpan");
    }

    addButtonToPanel(parent) {
        let that = this;
        that.element = $(`<button><img class="k-image itemBtnImg"/><span>${translateRef(that.currentRecord)}</span></button>`);
        parent.append(that.element);
        that.attachEvent();
    }

    attachEvent() {
        let that = this;
        that.element.kendoButton({
            click: e => {
                that.showNextLevelButtons();
            },
            imageUrl: downloadURLBrRecordId(that.currentRecord.id, that.currentRecord.entityType, DownloadPurpose.THUMBNAIL, false)
        });
        that.btnImg = that.element.find("img");
        that.btnImg.on("load", () => that.onButtonImageLoad());
        that.element.attr("title", translateRef(that.currentRecord));
        let itemButtonWidth = getCustomGUISettings().itemButtonWidth || 150;
        let itemButtonHeight = getCustomGUISettings().itemButtonHeight || 150;
        that.element.width(itemButtonWidth);
        that.btnImg.width(itemButtonWidth);
        that.element.height(itemButtonHeight);
        that.btnImg.height(itemButtonHeight * 0.8);
    }

    nextNotEmptyLevel(favouriteItem, level) {
        let levelsFetchers = [favouriteItem.favouritesLevel2, favouriteItem.favouritesLevel3, favouriteItem.favouritesLevel4, favouriteItem.favouritesLevel5];
        let iLevel = parseInt(level.substring("level".length));
        for (let cLevel = iLevel; cLevel < 5; cLevel++) {
            let nextLevel = levelsFetchers[cLevel - 1];
            if (nextLevel)
                return "Level" + (cLevel + 1);
        }
        return ItemButtonLevel.Level5;
    }

    showNextLevelButtons() {
        let that = this;
        if (that.currentRecord.entityType == SCEntities.InvItem) {
            let owner = that.customPanel.customSearcherWindow.owner;
            if (owner instanceof NamaGridWidget) {
                let ownerGrid = owner._kendoGrid();
                let insertionStartIndex = ownerGrid.dataSource.data().length - 1;
                owner.appendEmptyRows(1, insertionStartIndex, true).then(() => {
                    that.afterChooseItemAction();

                });
            } else {
                that.afterChooseItemAction();
            }
            return;
        }
        let favouriteItem = that.favouriteItem;
        let nextLevel = that.nextNotEmptyLevel(favouriteItem, that.level);
        let favouriteItemLevel = that.findFavouriteBtnLevel(favouriteItem, nextLevel);
        let searchInKlass = SCEntities.InvItem;
        if (favouriteItemLevel) {
            searchInKlass = that.findFavouriteBtnSearchKlass(favouriteItemLevel);
        }
        let foreignKeyFieldId = that.findForeignKeyFieldId(searchInKlass, that.currentRecord.entityType, favouriteItem);
        let criteria = new JSCriteriaBuilder();
        criteria.expressions = [];
        criteria.expressions.push({
            field: foreignKeyFieldId,
            operator: Operator.Equal,
            rightHandSide: that.currentRecord.id,
            relation: ExpressionRelationship.AND
        });
        let showItemsAsButtons = getCustomGUISettings().showItemsAsButtonsInLastSearchLevel;
        let normalItemLastLevel = isNullOrUndefined(showItemsAsButtons) || showItemsAsButtons === false;
        if (searchInKlass == SCEntities.InvItem && normalItemLastLevel) {
            that.customPanel.currentBreadCrumbLevel++;
            that.customPanel.addBreadCrumbItem(that.currentRecord);
            let searcherWindow = that.customPanel.customSearcherWindow;
            let searchCriteria = searcherWindow.defaultCriteria;
            if (searchCriteria)
                criteria = criteria.join(searchCriteria);
            let referenceSelectorPopup = new ReferenceSelectorPopup({
                owner: searcherWindow.owner,
                entityType: searcherWindow.entityType,
                refSelectedCallBack: searcherWindow.refSelectedCallBack,
                contextInfo: searcherWindow.contextInfo
                , inChangeDimsDialog: searcherWindow.inChangeDimsDialog,
                defaultCriteria: criteria
            });
            referenceSelectorPopup.afterInitUICallback = () => {
                that.customPanel.levelsContainer.css("display", "none");
                that.customPanel.searchingPart.css("display", "block");
                that.customPanel.searchingPart.find("div").remove();
                referenceSelectorPopup.rootElement.find(".searcherWindowBtns").find("#ok").remove();
                referenceSelectorPopup.rootElement.find(".searcherWindowBtns").find("#cancel").remove();
                that.customPanel.searchingPart.append(referenceSelectorPopup.rootElement);
                that.customPanel.setGridHeight();
            };
            referenceSelectorPopup.showPopup(true);
            return;
        }
        that.showRecords(searchInKlass, criteria, favouriteItem, nextLevel);
    }

    afterChooseItemAction() {
        let that = this;
        that.customPanel.customSearcherWindow.refSelectedCallBack(that.currentRecord);
        if (!localStorage.getItem("doNotAutoCloseSearcher") || localStorage.getItem("doNotAutoCloseSearcher") === "false")
            that.customPanel.customSearcherWindow.dialog.closeWindow();
    }

    showRecords(searchInKlass, criteria, favouriteItem, nextLevel) {
        let that = this;
        let pageSize = undefined;
        if (searchInKlass == SCEntities.InvItem)
            pageSize = getCustomGUISettings().maxItemButtonsToShowInSearch || 20;
        /**
         *
         * @type {namaTypes.DTOSearchResultSettings}
         */
        let searchResultSettings = {
            pageData: {pageNumber: 0, pageSize: pageSize || -1}, columnsToGet: ["id", "code", "entityType", "name1", "name2"]
        };
        /**
         *
         * @type {namaTypes.SearchRequest}
         */
        let request = {entityType: searchInKlass, criteria: criteria, searchResultSettings: searchResultSettings};
        ajaxJSON(NamaURLS.Search, {
            request: JSON.stringify(request)
        }, (result) => {
            let records = result.list.map(r => r.values);
            that.customPanel.addPanel(favouriteItem, records, nextLevel);
            that.customPanel.addBreadCrumbItem(that.currentRecord);
            if (!records || !records.length)
                that.customPanel.addNoRecordsToShowMsg(that.currentRecord, searchInKlass);
        });
    }

    findFavouriteBtnLevel(favouriteItem, level) {
        switch (level) {
            case ItemButtonLevel.Level2:
                return favouriteItem.favouritesLevel2;
            case ItemButtonLevel.Level3:
                return favouriteItem.favouritesLevel3;
            case ItemButtonLevel.Level4:
                return favouriteItem.favouritesLevel4;
            case ItemButtonLevel.Level5:
                return favouriteItem.favouritesLevel5;
        }
        return favouriteItem.favouritesLevel1.extraData && favouriteItem.favouritesLevel1.extraData[DomainBaseFieldIDs.ItemCategory_categoryLevel] ? favouriteItem.favouritesLevel1.extraData[DomainBaseFieldIDs.ItemCategory_categoryLevel] : null;
    }

    findFavouriteBtnSearchKlass(levelClassType) {
        if (isAnyEqualToFirst(levelClassType, "category1", "category2", "category3", "category4", "category5"))
            return "ItemCategory";
        return levelClassType;
    }


    findForeignKeyFieldId(searchingKlassName, entityType, favouriteItem) {
        let that = this;
        if (foreignKeyFieldIds.size)
            return foreignKeyFieldIds.get(that.generateKey(searchingKlassName, entityType, favouriteItem, null));

        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemSection, favouriteItem, null), "section");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemBrand, favouriteItem, null), "brand");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemClass1, favouriteItem, null), "itemClass1");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemClass2, favouriteItem, null), "itemClass2");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemClass3, favouriteItem, null), "itemClass3");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemClass4, favouriteItem, null), "itemClass4");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemClass5, favouriteItem, null), "itemClass5");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemClass6, favouriteItem, null), "itemClass6");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemClass7, favouriteItem, null), "itemClass7");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemClass8, favouriteItem, null), "itemClass8");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemClass9, favouriteItem, null), "itemClass9");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemClass10, favouriteItem, null), "itemClass10");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemCategory, favouriteItem, "category1"), "category1");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemCategory, favouriteItem, "category2"), "category2");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemCategory, favouriteItem, "category3"), "category3");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemCategory, favouriteItem, "category4"), "category4");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.InvItem, SCEntities.ItemCategory, favouriteItem, "category5"), "category5");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemBrand, SCEntities.ItemSection, favouriteItem, null), "section");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemCategory, SCEntities.ItemSection, favouriteItem, null), "section");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass1, SCEntities.ItemSection, favouriteItem, null), "section");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass2, SCEntities.ItemSection, favouriteItem, null), "section");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass2, SCEntities.ItemClass1, favouriteItem, null), "parent");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass3, SCEntities.ItemSection, favouriteItem, null), "section");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass3, SCEntities.ItemClass2, favouriteItem, null), "parent");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass3, SCEntities.ItemClass1, favouriteItem, null), "itemClass1");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass4, SCEntities.ItemSection, favouriteItem, null), "section");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass4, SCEntities.ItemClass3, favouriteItem, null), "parent");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass4, SCEntities.ItemClass2, favouriteItem, null), "itemClass2");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass4, SCEntities.ItemClass1, favouriteItem, null), "itemClass1");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass5, SCEntities.ItemSection, favouriteItem, null), "section");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass5, SCEntities.ItemClass4, favouriteItem, null), "parent");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass5, SCEntities.ItemClass3, favouriteItem, null), "itemClass3");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass5, SCEntities.ItemClass2, favouriteItem, null), "itemClass2");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass5, SCEntities.ItemClass1, favouriteItem, null), "itemClass1");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass6, SCEntities.ItemSection, favouriteItem, null), "section");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass6, SCEntities.ItemClass5, favouriteItem, null), "parent");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass6, SCEntities.ItemClass4, favouriteItem, null), "itemClass4");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass6, SCEntities.ItemClass3, favouriteItem, null), "itemClass3");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass6, SCEntities.ItemClass2, favouriteItem, null), "itemClass2");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass6, SCEntities.ItemClass1, favouriteItem, null), "itemClass1");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass7, SCEntities.ItemSection, favouriteItem, null), "section");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass7, SCEntities.ItemClass6, favouriteItem, null), "parent");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass7, SCEntities.ItemClass5, favouriteItem, null), "itemClass5");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass7, SCEntities.ItemClass4, favouriteItem, null), "itemClass4");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass7, SCEntities.ItemClass3, favouriteItem, null), "itemClass3");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass7, SCEntities.ItemClass2, favouriteItem, null), "itemClass2");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass7, SCEntities.ItemClass1, favouriteItem, null), "itemClass1");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass8, SCEntities.ItemSection, favouriteItem, null), "section");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass8, SCEntities.ItemClass7, favouriteItem, null), "parent");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass8, SCEntities.ItemClass6, favouriteItem, null), "itemClass6");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass8, SCEntities.ItemClass5, favouriteItem, null), "itemClass5");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass8, SCEntities.ItemClass4, favouriteItem, null), "itemClass4");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass8, SCEntities.ItemClass3, favouriteItem, null), "itemClass3");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass8, SCEntities.ItemClass2, favouriteItem, null), "itemClass2");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass8, SCEntities.ItemClass1, favouriteItem, null), "itemClass1");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass9, SCEntities.ItemSection, favouriteItem, null), "section");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass9, SCEntities.ItemClass8, favouriteItem, null), "parent");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass9, SCEntities.ItemClass7, favouriteItem, null), "itemClass7");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass9, SCEntities.ItemClass6, favouriteItem, null), "itemClass6");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass9, SCEntities.ItemClass5, favouriteItem, null), "itemClass5");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass9, SCEntities.ItemClass4, favouriteItem, null), "itemClass4");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass9, SCEntities.ItemClass3, favouriteItem, null), "itemClass3");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass9, SCEntities.ItemClass2, favouriteItem, null), "itemClass2");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass9, SCEntities.ItemClass1, favouriteItem, null), "itemClass1");

        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass10, SCEntities.ItemSection, favouriteItem, null), "section");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass10, SCEntities.ItemClass9, favouriteItem, null), "parent");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass10, SCEntities.ItemClass8, favouriteItem, null), "itemClass8");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass10, SCEntities.ItemClass7, favouriteItem, null), "itemClass7");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass10, SCEntities.ItemClass6, favouriteItem, null), "itemClass6");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass10, SCEntities.ItemClass5, favouriteItem, null), "itemClass5");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass10, SCEntities.ItemClass4, favouriteItem, null), "itemClass4");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass10, SCEntities.ItemClass3, favouriteItem, null), "itemClass3");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass10, SCEntities.ItemClass2, favouriteItem, null), "itemClass2");
        foreignKeyFieldIds.set(that.generateKey(SCEntities.ItemClass10, SCEntities.ItemClass1, favouriteItem, null), "itemClass1");
        return foreignKeyFieldIds.get(that.generateKey(searchingKlassName, entityType, favouriteItem, null));
    }

    generateKey(searchInKlass, relatedEntityType, favouriteItem, levelPartToAdd) {
        return searchInKlass + CommonConstants.SEPARATOR + relatedEntityType + CommonConstants.SEPARATOR + this.keyLevelPartIfCategory(
            relatedEntityType, favouriteItem, levelPartToAdd);
    }

    keyLevelPartIfCategory(relatedEntityType, favouriteItem, currentLevel) {
        let that = this;
        if (areNotEqual(relatedEntityType, SCEntities.ItemCategory))
            return "";
        return getFirstNotNullObj(currentLevel, that.findFavouriteBtnLevel(favouriteItem, that.level));
    }
}

